import Base from "../../base";
import SideMenu from "../SideMenu";

import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Title from "../../../components/ui/Title";
import { faDolly } from "@fortawesome/pro-regular-svg-icons";
import ItemForm from "./Form";
import { useNavigate } from "react-router-dom";
import { pickBy } from "lodash";

function ItemCreateForm() {
  const form = useForm();
  const authUser = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      const sanitizedData = pickBy(
        data,
        (value) =>
          value &&
          (value > 0 ||
            value.length > 0 ||
            (typeof value === "object" &&
              !Array.isArray(value) &&
              value !== null))
      );
      await axiosConfig
        .post(process.env.REACT_APP_API_URL + "/api/items", {
          ...sanitizedData,
          partner: authUser.user.partner,
        })
        .then((response) => {
          if (response?.status === 201 && response?.data) {
            toast.success(t("settings.items.created"), {
              theme: "colored",
              hideProgressBar: true,
            });
            navigate("/settings/items/" + response.data.id);
          }
        });
    } catch (e) {
      console.log(e);
      if (e.response.status !== 200 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10">
          <div className="lg:p-8 lg:px-10 lg:bg-white rounded-lg">
            <Title icon={faDolly} title={t("settings.items.create")} />

            <ItemForm form={form} onSubmit={onSubmit} />
          </div>
        </div>
      </div>
    </Base>
  );
}

export default ItemCreateForm;
